import ImageButton from "@/components/button/image-button";
import PovButton from "@/components/button/pov-button";
import XrayButton from "@/components/button/xRay-button";
import { useExplorationStore } from "@/store/explorationStore";
import Image from "src/components/image";

export default function ExplorationSideControl() {
  const triggerResetOnlyRotationEvent = useExplorationStore(
    (state) => state.triggerResetOnlyRotationEvent,
  );

  const onRotateClick = () => {
    triggerResetOnlyRotationEvent();
  };

  return (
    <div className="flex w-full justify-end p-[20px] pb-[30px]">
      <div className="flex flex-col gap-4">
        <XrayButton mode={"exploration"} />
        <PovButton />
        <ImageButton
          className="button-glass-blur"
          src="/assets/icon_restore.png"
          onClick={() => onRotateClick()}
          alt="rotate icon"
          size={24}
        />
      </div>
    </div>
  );
}
